import React, { Component, PropTypes as pt } from 'react';
import Select from 'react-select';


function getData (props) {
    let reduced = [];
    switch (props.preferenceName) {
        // case "category":
        //     const { categories } = props;
        //     // return categories.reduce(function (a, b) {
        //     //     return a.concat(b.categoryName);
        //     // }, []);
        //     categories.map(function (c, i) {
        //         reduced.push({
        //             label: c.categoryName,
        //             value: c.categoryName
        //             // value: c.categoryID
        //         });
        //     });
        //     return reduced;

        case "location": return props.locations.map(location => {
            return {
                value: location,
                label: location.locationName
            }
        })
        case "keyword": return props.keywords.map(keyword => {
            return {
                value: keyword,
                label: keyword.keyword
            }
        })
    }
}

function getName (preferenceName) {
    switch (preferenceName) {
        case "category": return "Categories";
        case "location": return "Locations";
        case "keyword": return "Keywords";
    }
}

class MetadataSelect extends Component {
    constructor (props) {
        super(props);

        const data = getData(props);

        this.state = {
            data: data,
            value: props.value,
            edited: false
        };
    }

    componentWillReceiveProps (nextProps) {
        if (this.state.edited) {
            this.setState({
                edited: false,
                value: nextProps.value
            });
        }
    }

    render () {
        const { data } = this.state;
        if (!data || !data.length) {
            return (<blockquote>
                <em>No {getName(this.props.preferenceName)} available.</em>
            </blockquote>);
        }

        const self = this
        return (<div>
            <Select
                value={getOption(self.props.value)}
                options={data}
                onChange={function(selected) {
                    if (selected === null) {
                        self.setState({
                            edited: true,
                            value: null
                        })
                        self.props.storeEdits(null)
                    } else {
                        self.setState({
                            edited: true,
                            value: selected.label
                        });
                        self.props.storeEdits(selected.label)
                    }
                }}
            />
        </div>);
    }
}

const getOption = selected => {
    if (selected === null) return null
    if (typeof selected === 'string') {
        return {value:selected, label:selected}
    } else {
        return {value: selected.label, label: selected.label}
    }
}

MetadataSelect.propTypes = {};

export default MetadataSelect;
